import { useQuery } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { z } from 'zod/v4';
import { addResourceNameToQueryResult, useAxiosInstance } from './utils';
import type { ApiError } from './utils/types';

const DisputedInvoicesSchema = z
  .object({
    totalInvoicesDisputed: z.preprocess(val => Number(val), z.number()),
  })
  .transform(({ totalInvoicesDisputed }) => totalInvoicesDisputed);

export type DisputedInvoices = z.infer<typeof DisputedInvoicesSchema>;

export async function loadDisputedInvoicesFn(axiosInstance: Promise<AxiosInstance>) {
  const instance = await axiosInstance;
  const { data } = await instance.get('analytics/disputed_invoices');

  return DisputedInvoicesSchema.parse(data);
}

export function useLoadDisputedInvoices() {
  const axiosInstance = useAxiosInstance();

  const queryResult = useQuery<DisputedInvoices, ApiError>({
    queryKey: ['disputed-invoices'],
    queryFn: () => loadDisputedInvoicesFn(axiosInstance),
  });

  return addResourceNameToQueryResult<DisputedInvoices, ApiError, 'disputedInvoices'>(
    'disputedInvoices',
    queryResult,
  );
}
